var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fi-table',{attrs:{"fields":_vm.fields,"items":_vm.sort,"loader":"products:fetch","empty-label":_vm.$t("notFound"),"responsive":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return _vm._l((items),function(product){return _c('product-list-item',{key:product.id,attrs:{"product":product}})})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }